import React from "react";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { useValidators } from "../../../helpers/validation";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { FormSubmitHandler } from "../../../common/models";
import { handleFormServerErrors } from "../../../helpers/errorHandling";
import FormError from "../FormError";
import TextInput from "../TextInput";
import Button from "../../button/Button";
import SubmitButton from "../SubmitButton";
import { useNavigate } from "../../../helpers/navigationHelpers";

interface Props {
  onSubmit: FormSubmitHandler<PasswordRecoveryFormValues>;
}

export interface PasswordRecoveryFormValues {
  username: string;
}

const PasswordRecoveryForm: React.FC<Props> = (props): React.ReactElement => {
  const { tInput, tError } = useCustomTranslation();
  const validators = useValidators();

  const navigate = useNavigate();

  const methods = useForm<PasswordRecoveryFormValues>({
    defaultValues: {
      username: "",
    },
    mode: "onBlur",
  });

  const onSubmit: SubmitHandler<PasswordRecoveryFormValues> = async (data) => {
    try {
      await props.onSubmit(data);
    } catch (e) {
      handleFormServerErrors(e, tError, methods.setError);
    }
  };

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="sm:w-[480px]">
        <TextInput
          name="username"
          placeholder={tInput("username_input")}
          type="email"
          required
          options={{
            required: validators.required,
          }}
        />
        <FormError />
        <div className="mt-6 flex flex-col sm:flex-row sm:justify-between">
          <Button
            label={tInput("back_to_login")}
            onClick={() => navigate.goTo("/")}
            className="mb-2 sm:mb-0"
          />
          <SubmitButton
            label={tInput("password_recovery_button")}
            icon="arrow-right"
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default PasswordRecoveryForm;
